<div id="content" class="allcp-form" ng-controller="FormAnalyticController">
    <div ng-include="'modules/company/menus/report_menu.html'"></div>
    <div class="row mt20">
        <div class="col-md-12">
            <div class="panel date-range" ng-if="data.forms.length > 0">
                <div class="panel-body" >
                    <div class="row">
                        <div class="col-md-6">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body">
                                    <h3 class="mbn mtn text-dark">{{ data.forms.length > 0 ? data.forms.length : 0 }} </h3>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Toplam Tanımlı Form</strong>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-md-6">
                            <div class="panel panel-tile border-chart text-center">
                                <div class="panel-body">
                                    <h3 class="mbn mtn text-dark">{{ data.count.total?data.count.total:0 }} </h3>
                                </div>
                                <div class="panel-footer p12">
                                    <strong>Toplam Form</strong>
                                </div>
                            </div>
                        </div>

                    </div>
                    <hr>
                    <!--
                    <div class="row">
                        <div class="col-md-6">
                            <canvas id="doughnut" class="chart chart-doughnut"
                                ng-if="chartData"
                                chart-data="chartData" 
                                chart-labels="series"
                                chart-legend="true" 
                                >
                            </canvas> 
                        </div>
                        <div class="col-md-6">
                            <canvas id="line" class="chart chart-line" 
                                ng-if="data.chart"
                                chart-data="chart2Data"
                                chart-labels="data.chart.labels"
                                chart-legend="true"
                                chart-series="lineSeries"
                                >
                            </canvas>
                        </div>
                    </div>
                    <hr>
                    -->
                    <h4>Form Adı : {{ data.selected_form.name }}</h4>
                    <div class="table-responsive allcp-form" ng-if="data.forms.length > 0">
                        <table class="table table-hover tc-checkbox-1 fs13">

                            <thead>
                            <tr class="bg-light">
                                <th class="w100">Müşteri</th>
                                <th class="w100">Personel</th>
                                <th class="w100">Kargo No</th>
                                <th class="w100">Tarih</th>
                                <th class="w100" ng-repeat="item in data.selected_form.fields">
                                    {{ item.field_name }}
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr class="text-left" 
                                dir-paginate="item in data.form_data.data | itemsPerPage: 30" 
                                total-items="data.form_data.total" 
                                current-page="data.form_data.current_page">
                                <td class="text-left">
                                    {{ item.customer.customer_name }}
                                </td>
                                <td>
                                    {{ item.worker.full_name }}
                                </td>
                                <td>
                                    <a href="#" ng-click="getOrderDetails(item)">
                                        #{{ item.id }}
                                    </a>
                                </td>
                                <td>
                                    {{ item.created_at | amDateFormat:'MM/DD/YYYY, HH:mm:ss' }}
                                </td>
                                <td ng-repeat="field in data.selected_form.fields">
                                    <div ng-repeat="value in item.form_values" ng-if="field.id == value.form_field_id">
                                        <span ng-if="field.field_type == 'image'">
                                            <a href="https://s3.us-west-2.amazonaws.com/hodxpress/{{ value.value }}" target="__BLANK" ng-if="value.value.length > 0" >
                                                <img
                                                    ng-src="https://s3.us-west-2.amazonaws.com/hodxpress/{{ value.value }}" 
                                                    class="img-thumbnail" width="150px">
                                            </a>
                                            <span ng-if="value.value.length == 0">Resim Eklenmemiş</span>
                                        </span>
                                        <span ng-if="field.field_type != 'image' && field.field_type != 'date' && field.field_type != 'checkbox'">
                                            <span ng-if="value.value.length > 0">{{ value.value }}</span>
                                            <span ng-if="value.value.length == 0">Bilgi Girilmemiş</span>
                                        </span>
                                        <span ng-if="field.field_type == 'date'">
                                            <span ng-if="value.value.length > 0">{{ value.value | amUtc | amDateFormat:'MM/DD/YYYY' }}</span>
                                            <span ng-if="value.value.length == 0">Bilgi Girilmemiş</span>
                                        </span>
                                            
                                        <span ng-if="field.field_type == 'checkbox'">
                                            <span ng-if="value.value.length > 0" ng-repeat="i in getArrayVal(value.value) track by $index ">{{ i }} ,</span>
                                            <span ng-if="value.value.length == 0">Bilgi Girilmemiş</span>
                                        </span>    
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <dir-pagination-controls 
                            boundary-links="true" 
                            on-page-change="getPage(newPageNumber)" 
                            template-url="dirPagination.tpl.html"
                            class="pagination-lg pagination">
                        </dir-pagination-controls>
                    </div>

                    <div class="table-responsive" ng-if="data.forms.length == 0">
                        <div class="alert alert-default pastel">
                            <i class="fa fa-info pr10"></i>
                            <strong>
                                Kayıtlı form bulunamadı! <a href="/form/yeni">Buraya</a> tıklayarak yeni form oluşturubilirsiniz.
                            </strong>
                        </div>
                    </div>

                </div>
            </div>

            <div class="panel date-range" ng-if="data.forms.length == 0">
                    <div class="panel-body" >
                    <h5>Müşteri form raporlarını oluşturabilmeniz için önce Form oluşturmanız gerekmektedir. <a href="/form/yeni">Buraya</a> tıklayarak yeni form oluşturubilirsiniz.</h5>
                </div>
            </div>
        </div>
    </div>
</div>
